import http from '../../utils/fetch'
import updownfile from '../../utils/updownfile'

export default {
    baseurl: '/api/swyl/v1/demo/bscBatchModifyManager',

    // 提交批量修改
    submit(q) {
        return http.post(this.baseurl + '/submit', q)
    },

    // 分页查询批次列表
    selectPage(q) {
        return http.post(this.baseurl + '/selectPage', q)
    },

    // 根据批次号查询详情
    selectDetailByBatchNo(batchNo) {
        return http.post(this.baseurl + '/selectDetailByBatchNo', { batchNo: batchNo })
    },

    // 审批
    approve(q) {
        return http.post(this.baseurl + '/approve', q)
    },

    // 根据条件查询型号经理列表
    selectProjingliByCondition(q) {
        return http.post(this.baseurl + '/selectProjingliByCondition', q)
    },

    // 导出Excel
    downloadExcel(q) {
        updownfile.down(`${this.baseurl}/downloadExcel`, q, 'get')
    }
}
